module.exports = __webpack_public_path__ + "img/cosmetique.1999adf4.png";